import { defineStore } from 'pinia'
import { nextTick, ref, computed } from 'vue'
import { UseKftContext } from '~/composables/useKftContext'

export type KftNotificationType = 'INFO' | 'SUCCESS' | 'WARNING' | 'ERROR'

export interface KftNotification {
  title?: string
  message: string
  type: KftNotificationType
  showIcon?: boolean
  htmlContent?: string
  persist?: boolean
}

export const useNotificationsStore = defineStore('notifications', () => {
  const { $scrollToTop } = UseKftContext()

  const notifications = ref<KftNotification[]>([])

  const removeNotification = (id: number) => {
    if (id > -1 && notifications.value.length > id) {
      notifications.value.splice(id, 1)
    }
  }

  const addNotification = async (
    notification: KftNotification,
    { shouldScrollToTop }: { shouldScrollToTop?: boolean } = {
      shouldScrollToTop: true,
    }
  ) => {
    const newIdx = notifications.value.length
    notifications.value = [...notifications.value, notification]
    if (shouldScrollToTop && $scrollToTop) {
      await $scrollToTop()
    }

    await nextTick()

    return () => removeNotification(newIdx)
  }

  const handleCloseNotification = () => {
    if (notifications.value.length > 0) {
      notifications.value.shift()
    }
  }

  const clearNonPersistentNotifications = () => {
    notifications.value = notifications.value.filter((n) => n.persist)
  }

  return {
    notifications: computed(() => notifications.value),
    addNotification,
    handleCloseNotification,
    clearNonPersistentNotifications,
  }
})
